import React from 'react';
import {
  BaseAnswer,
  SurveyQuestionOptionVariant,
} from '@x-guard/xgac-types/xgac';
import styles from './style.module.scss';

interface LikertScaleOptionProps {
  id: number;
  src: string;
  color: string;
  option: {
    id: number;
    src: string;
    color: string;
    label: string;
    value: number;
    variant: SurveyQuestionOptionVariant;
  };
  hovered: number | null;
  onClick: (response: BaseAnswer) => void;
  handleMouseEnter: (id: number) => void;
  handleMouseLeave: () => void;
}

const LikertScaleOption: React.FC<LikertScaleOptionProps> = ({
  id,
  src,
  color,
  option,
  hovered,
  onClick,
  handleMouseEnter,
  handleMouseLeave,
}) => {

  return (
    <div className={styles['likert-option-container']}>
      <img
        src={src}
        alt={`Likert option ${option}`}
        className={`${styles['likert-option']} 
          ${hovered === id ? styles.hovered : ''} 
          ${hovered !== null && hovered !== id ? styles.faded : ''}`}
        onClick={() => onClick({ value: option.value, label: option.label })}
        onMouseEnter={() => handleMouseEnter(id)}
        onMouseLeave={handleMouseLeave}
      />
      <span
        className={`${styles['option-text']} ${styles[color as keyof typeof styles]}
          ${hovered !== null && hovered !== id ? styles.faded : ''}`}
      >
        {option.label}
      </span>
    </div>
  );

};

export default LikertScaleOption;
